import Swiper from '../../../../node_modules/swiper/swiper-bundle.mjs';

export const initCatalogLinksSlider = function() {
  const sliderCatalogLinks = document.querySelector('[data-catalog-links="slider"]');
  if (!sliderCatalogLinks) {
    return;
  }

  const swiperCatalogLinks = function() {
    new Swiper(sliderCatalogLinks, {
        spaceBetween: 10,
        slidesPerView: 2,
        navigation: {
          nextEl: '[data-catalog-links="arrow-next"]',
          prevEl: '[data-catalog-links="arrow-prev"]'
        },
        breakpoints: {
          360: {
            spaceBetween: 10,
            slidesPerView: 2
          },
          768: {
            spaceBetween: 6,
            slidesPerView: 4
          },
          1200: {
            spaceBetween: 21,
            slidesPerView: 6
          }
        }
      }
    );
  }
  swiperCatalogLinks();
};
